import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLinkedinRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#0077b7",
		d: "M25.5 4.5H7a2 2 0 0 0-2 2V25c0 1 1 2 2 2h18.5a2 2 0 0 0 2-2V6.5a2 2 0 0 0-2-2M12 23.9l-.6.6H8.8l-.5-.6V13.4q0-.6.5-.6h2.6q.5 0 .6.6zm-2-12.1A2.4 2.4 0 1 1 10 7a2.4 2.4 0 0 1 0 4.8M25 24q0 .5-.5.5h-2.7a.5.5 0 0 1-.6-.5v-5c0-.7.3-3.2-1.9-3.2-1.7 0-2 1.7-2 2.5V24q0 .5-.6.5h-2.6a.5.5 0 0 1-.6-.5V13.3q0-.5.6-.5h2.6q.5 0 .5.5v1q.9-1.6 3.5-1.7c4.4 0 4.3 4 4.3 6.3z"
	})
});
export default SvgLinkedinRegularIcon;
